// import getTable from "./../../../datamock/getTable/getTable";
// import getDetailContent from "./../../../datamock/getDetailContent/getDetailContent";
// import lodash from "lodash";
import baseUrl from "./../../util/backend";
import axios from "@/axios";
import {
  table,
  banner,
  setting,
  board,
  tableAndHorizal,
} from "../../../mockup/outside";
import { banner2, content } from "../../../mockup/inside";

// import { forEach } from "core-js/core/array";

export default {
  ///getTable//////
  async getTable({ commit, state }, payload) {
    try {
      // console.log("id_user nana", state.id_user);
      const response = await axios.get(
        `${baseUrl()}/getTable?path=${payload}&id_user=${state.id_user}`
      );
      console.log("table", response.data);
      console.log("table", JSON.stringify(response.data.data.data[0]));
      commit("GET_TABLE", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },

  ///getTabComponent////
  async getTab({ commit }, payload) {
    try {
      const response = await axios.get(`${baseUrl()}/getTab?path=${payload}`);
      for (const index of response.data.data) {
        if (index.isActive) {
          let active = index;
          console.log(active);
          commit("GET_TAB_ACTIVE", active);
        }
      }
      // console.log(response.data);
      commit("GET_TAB", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },

  ///getRenderDetail
  async getRenderDetail({ commit }, payload) {
    console.log("payload", payload);
    try {
      // const response = await axios.get(
      //   `${baseUrl()}/getDetailContent?path=${payload.path}&detail=${payload.detail}&id_user=${payload.id_user}`
      // );
      console.log("detail", tableAndHorizal.data.componentDetail);
      // commit("GET_RENDER_DETAIL",tableAndHorizal.data.data)
      commit("GET_RENDER_DETAIL", tableAndHorizal.data.componentDetail);
      commit("GET_DETAIL_DATA", tableAndHorizal.data.data);
    } catch (error) {
      console.error(error);
    }
    // lodash.each(getDetailContent, a => {
    //   // console.log(a);
    //   if (a.slug === `${payload}`) {
    //     console.log("aaa", a);
    //     commit("GET_RENDER_DETAIL", a.componentDetail);
    //     commit("GET_DETAIL_DATA", a.data);
    //   }
    //   // a.slug === payload ? commit("GET_RENDER_DETAIL", a.componentDetail),log : null;
    // });
  },

  ///change tab component active
  async changeTabActive({ commit, state }, payload) {
    const tab = state.tab;
    for await (const index of tab) {
      if (payload.path == index.path) {
        index.isActive = true;
        // console.log("index active", index);

        commit("GET_TAB_ACTIVE", index);
      } else {
        index.isActive = false;
      }
    }
    console.log("tab", tab);
    commit("GET_TAB", tab);
  },
  async getPage({ commit }, e) {
    try {
      // console.log("id_user nana", state.id_user);
      console.log(e);
      const response = await axios.get(
        baseUrl() +
          e.url +
          "?" +
          (e.page ? "page=" + e.page : "") +
          (e.filter ? "&" + e.filter : "")
      );
      console.log("table", response.data);

      commit("GET_PAGE", response.data);
      commit("GET_TAB", response.data.table.tab);

      // console.log("table", JSON.stringify(response.data.data.data[0]));
      // commit("GET_TABLE", response.data.data);
    } catch (error) {
      console.error(error);
    }
    // const response = await axios.get(
    //     `xxx`
    //   );
    // console.log("state.tab", table.table.tab);
  },
  async getPage_2({ commit }, payload) {
    // const response = await axios.get(
    //     `xxx`
    //   );
    console.log("state.tab", table.table.tab);
    commit("GET_PAGE", banner);
    commit("GET_TAB", banner.table.tab);
    // commit("GET_TAB", );
  },
  async getPage_3({ commit }, payload) {
    // const response = await axios.get(
    //     `xxx`
    //   );
    // console.log("state.tab", table.table.tab);
    commit("GET_PAGE", setting);
    commit("GET_TAB", banner.table.tab);
    // commit("GET_TAB", );
  },

  async get_language({ commit }, payload) {
    // console.log(banner2)
    commit("GET_LANGUAGE", banner2.language);
  },

  async switch_language({ commit, state }, payload) {
    commit("SWITCH_LANGUAGE", payload);
  },

  async get_banner({ commit }, payload) {
    // console.log("banner_2",banner2);

    const x = banner2.language.filter((a) => {
      return a.value == true;
    });

    // console.log(banner2)
    for (let [key, value] of Object.entries(banner2)) {
      // console.log(key,x[0].name);
      //console.log("value",value)
      if (x[0].name == key) {
        commit("CHANGE_LANGUAGE", value);
      } else {
      }
    }
    commit("CHANGE_BANNER_DATE", {
      startDate: banner2.startDate,
      endDate: banner2.endDate,
    });
    commit("CHANGE_PUBLISH", banner2.isPublish);
  },

  async get_content({ commit }) {
    commit("GET_CONTENT", content);
  },

  async change_content({ commit }, payload) {
    // console.log("payload in action",payload)
    commit("CHANGE_CONTENT", payload);
  },
  ////////////////////////////////////////////

  async page_banner({ commit }, payload) {
    // console.log("page_banner",payload)
    commit("PAGE_BANNER", banner2);
  },

  async get_bannertype({ commit }) {
    // console.log("get_bannertype",banner2.type)
    commit("GET_BANNERTYPE", banner2.type);
  },

  async push_content({ commit, getters }, payload) {
    const content = this.getters["general/content"];
    for (let [key, value] of Object.entries(content)) {
      // console.log(key,value)
      const item = {
        sub_content_img: null,
        text: null,
      };

      if (payload === key) {
        let subcontent = value;
        subcontent.sub_content.push(item);
        // console.log("subcontent",subcontent)
        value = subcontent;

        commit("PUSH_CONTENT", content);
      }
    }
  },

  async delete_content({ commit, getters }, payload) {
    const content = this.getters["general/content"];
    for (let [key, value] of Object.entries(content)) {
      if (payload.lang === key) {
        let subcontent = value;
        subcontent.sub_content.splice(payload.index, 1);
        // console.log("subcontent",subcontent)
        value = subcontent;

        commit("PUSH_CONTENT", content);
      }
      console.log("deleted", payload);
    }
  },

  delete_img({ commit }, payload) {
    for (let [key, value] of Object.entries(banner2)) {
      console.log(key, value);
      if (payload === key) {
        // console.log(key,value)
        console.log("check");
        value.img = null;
      }
      //console.log("value",value)
    }
  },

  // async push_isShow ({commit},payload){
  //   console.log("???",payload.sub_content)
  //   const showImg = {isShow:false}

  //     for (let [key ,value] of Object.entries(payload.sub_content)){
  //       console.log("log",key,value)
  //       console.log("length",payload.sub_content.length)
  //       if (!payload.sub_content[key].isShow){
  //       let newValue = value
  //       newValue.push(showImg)

  //       value = newValue
  //       // commit ("PUSH_ISSHOW",payload)
  //       }
  //     }

  //     console.log("new payload",payload)
  // }
};
